type FormHeaderProps = {
  children?: React.ReactNode;
  title: string;
  formInformation?: string;
};

export const FormHeader = ({ children, title, formInformation }: FormHeaderProps) => {
  return (
    <>
      <div className="inline-flex gap-2 items-center">
        <div className="text-gray-600 w-1/2">
          <p className="font-semibold text-lg">{title}</p>
        </div>
        <div className="inline-flex gap-2 w-1/2 flex-row-reverse">
          {children}
        </div>
      </div>
      {formInformation &&
        <div className="gap-4 gap-y-2 text-sm lg:col-span-2">
          <p>{formInformation}</p>
          <hr className="pb-4 mt-2" />
        </div>}
    </>
  );
};
